var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Form } from 'antd';
export var FormItem = styled(Form.Item)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 8px;\n\n  .ant-form-item-label {\n    padding: 0;\n  }\n"], ["\n  margin-bottom: 8px;\n\n  .ant-form-item-label {\n    padding: 0;\n  }\n"])));
var templateObject_1;
